import { 
    GET_PROFILE, 
    GET_PROFILE_SUCCESS, 
    GET_PROFILE_ERROR ,

    UPDATE_PROFILE, 
    UPDATE_PROFILE_SUCCESS, 
    UPDATE_PROFILE_ERROR ,

} from "./actionTypes";

const initialState = {
  profile: null,
  loading: false,
  error: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return { ...state, loading: true, error: null };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case GET_PROFILE_ERROR:
      return { ...state, loading: false, error: action.payload };
    // Mise à jour du profil
    case UPDATE_PROFILE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        loading: false,
        error: null,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default profileReducer;
